import React from 'react';
import {TableCellBaseProps} from "@material-ui/core";

interface CollapsibleTableCellProps extends TableCellBaseProps {
  content: React.ReactNode[];
}

const MultilineTableCell = (props: CollapsibleTableCellProps) => {
  return (
    <>
      {props.content.map((c, idx) =>
        React.isValidElement(c) ? React.cloneElement(c as any, { key: idx }) : <p key={idx}>{c}</p>
      )}
    </>
  );
};

export default MultilineTableCell;
